const language = {
    'pt': 
        {
            apagar:'Apagar',
            descricao_tarefa:' Descrição da tarefa',
            lista_anexos:       'Lista de anexos',
            add_new:            'Adicionar novo',
            avaiable:           'Disponível até',
            cancel:             'Cancelar', back: 'Voltar',
            close:              'Fechar',
            content:            'Conteúdo',
            content_add:        'Adicionar bloco',
            content_edit:       'Editar conteúdo',
            content_new:        'Novo conteúdo',
            content_list:       'Lista de conteúdos',
            content_remove:     'Remover bloco',
            dates:              'Datas',
            date_creation:      'Criação',
            date_avaiable:      'Disponível até',
            date_publication:   'Publicação',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            draft:              'Rascunho',
            doc_choose:         'Escolher PDF',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            layout:             'Tipo',
            multimedia:         'Multimédia',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            image:              'Imagem de destaque',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            page_config:        'Configuração da Página',
            page_parent:        'Parent',
            pages:              'Páginas',
            pdf_documents:      'Documentos PDF',
            preview:            'Pré-visualização',
            principal:          'Principal',
            publish:            'Publicar',
            published:          'Publicado',
            remove:             'Remover',
            schedule:           'Agendar',
            schedule_to:        'Agendado',
            seo_config:         'Configuração SEO',
            seo_description:    'Descrição SEO',
            seo_description_placeholder: 'Introduza a descrição SEO',
            seo_keywords:       'Keywords SEO',
            seo_keywords_small: '(separar por virgula)',
            seo_keywords_placeholder: 'Introduza as keywords SEO',
            seo_title:          'Título SEO',
            seo_title_placeholder: 'Introduza o título SEO',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_date_published: 'Data de Publicação',
            table_date_modified: 'Data de alteração',
            table_state:        'Estado',
            table_actions:      'Acções',
            text:               'Texto',
            title:              'Título',
            title_placeholder:  'Introduza o título',
            tooltip_accordion:  'Accordion',
            tooltip_card:       'Cartões',
            tooltip_list_left:  'Lista à esquerda',
            tooltip_list_right: 'Lista à direita',
            tooltip_list_alt:   'Lista alternada',
            tooltip_list_banner:   'Lista + banner',
            tooltip_tabs:       'Tabs',
            tooltip_normal:     'Texto',
            tooltip_text_image: 'Texto e Imagem',
            save:               'Salvar',   
            subtitle:           'Subtítulo',
            subtitle_placeholder:  'Introduza o subtítulo',  
            upload_image_error : 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n' ,
            youtube_choose:      'Youtube',             
        },
    'en':
        {
            apagar:                'Delete',
            descricao_tarefa :'Task description',
            lista_anexos:'List of files',
            add_new:            'Add new',
            avaiable:           'Avaiable until',
            cancel:             'Cancel', back: 'Voltar',
            close:              'Close',
            content:            'Content',
            content_add:        'Add block',
            content_edit:       'Edit content',
            content_new:        'New content',
            content_list:       'Content list',
            content_remove:     'Remove block',
            dates:              'Dates',
            date_creation:      'Creation',
            date_avaiable:      'Avaiable until',
            date_publication:   'Publication',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            description:        'Description',
            draft:              'Draft',
            doc_choose:         'Choose PDF',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Search',
            id:                 'ID',
            layout:             'Type',
            multimedia:         'Multimedia',
            name:               'Name',
            name_placeholder:   'Insert the name',
            image:              'Highlight image',
            images:             'Images',
            image_choose:       'Choose image',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem inserting element!',
            insert_success:     'Successful inserting element!',
            page_config:        'Page config',
            page_parent:        'Parent',
            pages:              'Pages',
            pdf_documents:      'PDF Documents',
            preview:            'Preview',
            principal:          'Principal',
            publish:            'Publicar',
            published:          'Publicado',
            remove:             'Remove',
            schedule:           'Schedule',            
            schedule_to:        'Schedule', 
            seo_config:         'SEO config',
            seo_description:    'SEO description',
            seo_description_placeholder: 'Insert the SEO description',
            seo_keywords:       'SEO keywords',
            seo_keywords_small: '(separate by comma)',
            seo_keywords_placeholder: 'Insert the SEO keywords',
            seo_title:          'SEO title',
            seo_title_placeholder: 'Insert the SEO title',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_date_published: 'Published date',
            table_date_modified: 'Modified date',
            table_state:        'State',
            table_actions:      'Actions',
            text:               'Text',
            title:              'Title',
            title_placeholder:  'Insert title',
            tooltip_accordion:  'Accordion',
            tooltip_card:       'Cartões',
            tooltip_list_left:  'Lista à esquerda',
            tooltip_list_right: 'Lista à direita',
            tooltip_list_alt:   'Lista alternada',
            tooltip_list_banner:   'Lista + banner',
            tooltip_tabs:       'Tabs',
            tooltip_normal:     'Texto',
            tooltip_text_image: 'Texto e Imagem',
            save:               'Save',
            subtitle:           'Subtitle',
            subtitle_placeholder:  'Insert subtitle', 
            upload_image_error : 'Only jpg, jpeg and png files are allowed.\nMaximum size: 10MB.\n\n',    
            youtube_choose:      'Youtube',   
        },
         'es':
         {
            apagar: 'Borrar',
descricao_tarefa: 'Descripción de la tarea',
lista_anexos: 'Lista de anexos',
add_new: 'Agregar nuevo',
avaiable: 'Disponible hasta',
cancel: 'Cancelar', back: 'Voltar',
close: 'Cerrar',
content: 'Contenido',
content_add: 'Agregar bloque',
content_edit: 'Editar contenido',
content_new: 'Nuevo contenido',
content_list: 'Lista de contenidos',
content_remove: 'Eliminar bloque',
dates: 'Fechas',
date_creation: 'Creación',
date_avaiable: 'Disponible hasta',
date_publication: 'Publicación',
date_last_update: 'Última actualización',
delete: 'Eliminar',
delete_title: 'Eliminar registro',
delete_text: '¿Está seguro de que desea continuar?',
delete_confirm: 'Sí',
delete_cancel: 'No',
delete_error: '¡Error al eliminar registro!',
delete_success: '¡Registro eliminado con éxito!',
description: 'Descripción',
draft: 'Borrador',
doc_choose: 'Elegir PDF',
edit: 'Editar',
edit_title: 'Editar registro',
edit_text: '¿Está seguro de que desea continuar?',
edit_confirm: 'Sí',
edit_cancel: 'No',
edit_error: '¡Error al actualizar registro!',
edit_success: '¡Registro actualizado con éxito!',
file_attach: 'Adjuntar archivo',
file_remove_all: 'Eliminar todo',
file_upload: 'Subir archivo',
file_upload_all: 'Subir todos',
filter_placeholder: 'Buscar',
id: 'ID',
layout: 'Tipo',
multimedia: 'Multimedia',
name: 'Nombre',
name_placeholder: 'Introduce el nombre',
image: 'Imagen destacada',
images: 'Imágenes',
image_choose: 'Elegir imagen',
insert_title: 'Nuevo registro',
insert_text: '¿Está seguro de que desea continuar?',
insert_confirm: 'Sí',
insert_cancel: 'No',
insert_error: '¡Error al insertar registro!',
insert_success: '¡Registro insertado con éxito!',
page_config: 'Configuración de página',
page_parent: 'Parent',
pages: 'Páginas',
pdf_documents: 'Documentos PDF',
preview: 'Previsualización',
principal: 'Principal',
publish: 'Publicar',
published: 'Publicado',
remove: 'Eliminar',
schedule: 'Programar',
schedule_to: 'Programado',
seo_config: 'Configuración SEO',
seo_description: 'Descripción SEO',
seo_description_placeholder: 'Introduce la descripción SEO',
seo_keywords: 'Palabras clave SEO',
seo_keywords_small: '(separadas por comas)',
seo_keywords_placeholder: 'Introduce las palabras clave SEO',
seo_title: 'Título SEO',
seo_title_placeholder: 'Introduce el título SEO',
table_rows_per_page: 'Registros por página:',
table_separator: 'de',
table_all: 'Todos',
table_title: 'Título',
table_parent: 'Parent',
table_date: 'Fecha',
table_date_published: 'Fecha de publicación',
table_date_modified: 'Fecha de modificación',
table_state: 'Estado',
table_actions: 'Acciones',
text: 'Texto',
title: 'Título',
title_placeholder: 'Introduce el título',
tooltip_accordion: 'Acordeón',
tooltip_card: 'Tarjetas',
tooltip_list_left: 'Lista a la izquierda',
tooltip_list_right: 'Lista a la derecha',
tooltip_list_alt: 'Lista alternada',
tooltip_list_banner: 'Lista + banner',
tooltip_tabs: 'Pestañas',
tooltip_normal: 'Texto',
tooltip_text_image: 'Texto e imagen',
save: 'Guardar',
subtitle: 'Subtítulo',
subtitle_placeholder: 'Introduce el subtítulo',
upload_image_error: 'Solo se permiten archivos jpg, jpeg y png.\nTamaño máximo: 10 MB.\n\n',
youtube_choose: 'YouTube',

         } ,
         'fr':
         {
apagar: 'Supprimer',
descricao_tarefa: 'Description de la tâche',
lista_anexos: 'Liste des pièces jointes',
add_new: 'Ajouter nouveau',
avaiable: 'Disponible jusqu’à',
cancel: 'Annuler',
close: 'Fermer',
content: 'Contenu',
content_add: 'Ajouter un bloc',
content_edit: 'Modifier le contenu',
content_new: 'Nouveau contenu',
content_list: 'Liste de contenus',
content_remove: 'Supprimer le bloc',
dates: 'Dates',
date_creation: 'Création',
date_avaiable: 'Disponible jusqu’à',
date_publication: 'Publication',
date_last_update: 'Dernière mise à jour',
delete: 'Supprimer',
delete_title: 'Supprimer l’enregistrement',
delete_text: 'Êtes-vous sûr de vouloir continuer ?',
delete_confirm: 'Oui',
delete_cancel: 'Non',
delete_error: 'Erreur lors de la suppression de l’enregistrement !',
delete_success: 'Enregistrement supprimé avec succès !',
description: 'Description',
draft: 'Brouillon',
doc_choose: 'Choisir un PDF',
edit: 'Modifier',
edit_title: 'Modifier l’enregistrement',
edit_text: 'Êtes-vous sûr de vouloir continuer ?',
edit_confirm: 'Oui',
edit_cancel: 'Non',
edit_error: 'Erreur lors de la mise à jour !',
edit_success: 'Enregistrement mis à jour avec succès !',
file_attach: 'Joindre un fichier',
file_remove_all: 'Tout supprimer',
file_upload: 'Téléverser un fichier',
file_upload_all: 'Téléverser tout',
filter_placeholder: 'Rechercher',
id: 'ID',
layout: 'Type',
multimedia: 'Multimédia',
name: 'Nom',
name_placeholder: 'Entrez le nom',
image: 'Image en vedette',
images: 'Images',
image_choose: 'Choisir une image',
insert_title: 'Nouvel enregistrement',
insert_text: 'Êtes-vous sûr de vouloir continuer ?',
insert_confirm: 'Oui',
insert_cancel: 'Non',
insert_error: 'Erreur lors de l’insertion !',
insert_success: 'Enregistrement inséré avec succès !',
page_config: 'Configuration de la page',
page_parent: 'Parent',
pages: 'Pages',
pdf_documents: 'Documents PDF',
preview: 'Aperçu',
principal: 'Principal',
publish: 'Publier',
published: 'Publié',
remove: 'Retirer',
schedule: 'Planifier',
schedule_to: 'Planifié',
seo_config: 'Configuration SEO',
seo_description: 'Description SEO',
seo_description_placeholder: 'Entrez la description SEO',
seo_keywords: 'Mots-clés SEO',
seo_keywords_small: '(séparés par des virgules)',
seo_keywords_placeholder: 'Entrez les mots-clés SEO',
seo_title: 'Titre SEO',
seo_title_placeholder: 'Entrez le titre SEO',
table_rows_per_page: 'Enregistrements par page :',
table_separator: 'de',
table_all: 'Tous',
table_title: 'Titre',
table_parent: 'Parent',
table_date: 'Date',
table_date_published: 'Date de publication',
table_date_modified: 'Date de modification',
table_state: 'État',
table_actions: 'Actions',
text: 'Texte',
title: 'Titre',
title_placeholder: 'Entrez le titre',
tooltip_accordion: 'Accordéon',
tooltip_card: 'Cartes',
tooltip_list_left: 'Liste à gauche',
tooltip_list_right: 'Liste à droite',
tooltip_list_alt: 'Liste alternée',
tooltip_list_banner: 'Liste + bannière',
tooltip_tabs: 'Onglets',
tooltip_normal: 'Texte',
tooltip_text_image: 'Texte et image',
save: 'Enregistrer',
subtitle: 'Sous-titre',
subtitle_placeholder: 'Entrez le sous-titre',
upload_image_error: 'Seuls les fichiers jpg, jpeg et png sont autorisés.\nTaille maximale : 10 Mo.\n\n',
youtube_choose: 'YouTube',

         } 
}

module.exports = {
    language
};